import React from 'react';
import ReactDOM from 'react-dom';
import AirlineListApp from './AirlineListApp';
import { I18nextProvider } from 'react-i18next';
import i18n from '../shared/I18next';

// Based on https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
if (typeof Object.assign != 'function') {
	(function () {
		Object.assign = function (target) {
			'use strict';
			// We must check against these specific cases.
			if (target === undefined || target === null) {
				throw new TypeError('Cannot convert undefined or null to object');
			}

			var output = Object(target);
			for (var index = 1; index < arguments.length; index++) {
				var source = arguments[index];
				if (source !== undefined && source !== null) {
					for (var nextKey in source) {
						if (source.hasOwnProperty(nextKey)) {
							output[nextKey] = source[nextKey];
						}
					}
				}
			}
			return output;
		};
	})();
}

const entryPoint = document.getElementById('js-airline-data');

if(entryPoint !== null) {
	const displayMode = entryPoint.dataset.mode || 'list';
    const languageDimension = entryPoint.dataset.dimensionLanguage;
    const marketDimension = entryPoint.dataset.dimensionMarket;
    const targetDimension = entryPoint.dataset.targetDimension;

	ReactDOM.render( <I18nextProvider i18n={i18n} >
		<AirlineListApp
			mode={displayMode}
            languageDimension = {languageDimension}
            marketDimension = {marketDimension}
            targetDimension = {targetDimension}
		/></I18nextProvider>, entryPoint);

	console.log(i18n, 'tata');
} else {
	console.log('NO js-airline-data');
}



// WEBPACK FOOTER //
// ./AirlineListApp/main.js